import React from 'react';
import PropTypes from 'prop-types';
import Cldr from 'utils/Cldr';
import clsx from '@strava/ui/clsx';
import I18n from 'utils/I18n';
import { useCheckoutContext } from '../../../state/CheckoutContext';
import { I18nPrefix } from '../../../shared/constants';

import styles from './Pricing.scss';

const Pricing = ({ isPrimary, label, showFootnote }) => {
  const { checkoutEntityState } = useCheckoutContext();
  const { duration, products } = checkoutEntityState;
  const cartData = products?.[duration];

  const amount = isPrimary ? cartData.billedToday : cartData.recurringAmount;
  const formattedAmount = Cldr.formatCurrency(amount, cartData.currency);

  return (
    <div className={styles.container}>
      <h4 className={clsx(styles.row, isPrimary && 'text-bold')}>
        <p>{label}</p>
        <p data-testid="bill-amount">
          {isPrimary
            ? formattedAmount
            : I18n.t(`${I18nPrefix}.summary.students.billing.price_per_year`, {
                price: formattedAmount
              })}
        </p>
      </h4>
      {showFootnote && (
        <small>
          {I18n.t(`${I18nPrefix}.summary.students.billing.cancel_anytime`)}
        </small>
      )}
    </div>
  );
};

Pricing.propTypes = {
  isPrimary: PropTypes.bool.isRequired,
  label: PropTypes.string.isRequired,
  showFootnote: PropTypes.bool.isRequired
};

export default Pricing;
